import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import Table from 'react-bootstrap/Table';
import { Typography } from "@mui/material";

const Master = () => {
  let masterIntro=  <Stack direction="horizontal" gap={4}>
  <div>
<img src="/masterphoto2.png" width={311} />
<Table><tbody><tr>
        <td></td>
        <td><img src="/masterphoto.jpg" /></td>
        <td></td>
      </tr></tbody></Table>

</div>
<div><Typography variant="h3"><b>永化法师，Master YongHua，Thích Vĩnh Hóa</b></Typography><br/><Typography variant="body1">永化法師出生於越南，1973年來到美國進修，得到明尼蘇達大學的學士及芝加哥大學商學院的碩士學位。法師的初衷是要回越南幫助重建戰後重創的家園，但在美國大公司工作幾十年並做到高層主管的位置後，開始對商界失去了興趣。就在這時，遇到宣化(XuanHua，Tuyên Hóa)上人的禪修法門，於是在1995年決定出家修行，並在1999年在滿覺，ManJue，Mãn Giác，和尚座下受具足戒。之後的兩年在台灣學習中文及戒律。 2001年法師回到美國，閉關至2005年。經過十年的苦修，法師發現這就是他生命中所追求的目標，所以決定此生致力於弘揚佛法。永化法師傳承宣化上人溈仰宗所教的禪法，還傳承了越南滿覺和尚的臨濟宗。在修行大乘佛法二十年之後，永化法師繼續著佛教「報師恩」的傳統來廣說經典及訓練下一代的修行者。這些年來，他幫助許多修行者得到比較高的修行程度。永化法師現在有十個出家弟子和很多在家弟子。在家弟子們來自十五個不同國家，年齡由一歲至八十多歲不等。雖然大家背景各異，但是都努力修行以期發掘自己最大的潛力來為眾生服務。<br/><br/>
永化法師會根據個人當前的修行程度指點大家適合自己的修行方法。開示時他會給大家很多問答時間，藉此來調整教學以契合個人需求。很多學生在法師的指點下得到更高的禪定，大幅度改善了身體健康狀況並能更好的與他人交往。<br/><br/>
您可以在 <a href="https://www.facebook.com/blichinesepage/">Facebook</a> 和 <a href="https://www.youtube.com/channel/UCE2xsGwxwNN1c7E0dGiWAYg">YouTube</a>上找到更多永化法師教學的內容。</Typography></div>
</Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
  masterIntro= <><Typography variant="h3"><b>永化法师</b><br/><b>Master YongHua</b><br/><b>Thích Vĩnh Hóa</b></Typography><br/><img src="/masterphoto2.png" width={"100%"} />
  <div><Typography variant="body1">永化法師出生於越南，1973年來到美國進修，得到明尼蘇達大學的學士及芝加哥大學商學院的碩士學位。法師的初衷是要回越南幫助重建戰後重創的家園，但在美國大公司工作幾十年並做到高層主管的位置後，開始對商界失去了興趣。就在這時，遇到宣化(XuanHua，Tuyên Hóa)上人的禪修法門，於是在1995年決定出家修行，並在1999年在滿覺，ManJue，Mãn Giác，和尚座下受具足戒。之後的兩年在台灣學習中文及戒律。 2001年法師回到美國，閉關至2005年。經過十年的苦修，法師發現這就是他生命中所追求的目標，所以決定此生致力於弘揚佛法。永化法師傳承宣化上人溈仰宗所教的禪法，還傳承了越南滿覺和尚的臨濟宗。在修行大乘佛法二十年之後，永化法師繼續著佛教「報師恩」的傳統來廣說經典及訓練下一代的修行者。這些年來，他幫助許多修行者得到比較高的修行程度。永化法師現在有十個出家弟子和很多在家弟子。在家弟子們來自十五個不同國家，年齡由一歲至八十多歲不等。雖然大家背景各異，但是都努力修行以期發掘自己最大的潛力來為眾生服務。<br/><br/>
  <img src="/masterphoto.jpg" style={{float: "right", margin: "15px"}} />
  永化法師會根據個人當前的修行程度指點大家適合自己的修行方法。開示時他會給大家很多問答時間，藉此來調整教學以契合個人需求。很多學生在法師的指點下得到更高的禪定，大幅度改善了身體健康狀況並能更好的與他人交往。<br/><br/>
  您可以在 <a href="https://www.facebook.com/blichinesepage/">Facebook</a> 和 <a href="https://www.youtube.com/channel/UCE2xsGwxwNN1c7E0dGiWAYg">YouTube</a>上找到更多永化法師教學的內容。</Typography></div></>;
  }

  return (
  <><NavigationBar/>
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    src="/masterBanner.png"/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
  {masterIntro}
  </Layout>
  </>
)}

export default Master
